const getItem = (key: string) => {
  return localStorage.getItem(key);
};

export default getItem;
